/// <reference path="../../../../Scripts/typings/q/q.d.ts" />
/// <reference path="../../../../Scripts/typings/toastr/toastr.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/shopitemtemplate/viewmodels/createshopitems',["require", "exports", "models/breeze", "services/trace", "common/parts", "common/string", "areas/navigationmanager/parts/loadmodules", "areas/organizationmanager/services/organizationsrepository", "areas/organizationmanager/services/mappings", "areas/shopitemtemplate/services/mappings", "areas/shopitemtemplate/services/shopitemtemplaterepository", "common/viewmodelbase", "services/navigator"], function (require, exports, Data, Trace, Parts, String, navimanLoadModules, orgaRepository, orgaMapping, Mapping, Repository, common, navigator) {
    "use strict";
    var ShopItemCreateViewModel = (function (_super) {
        __extends(ShopItemCreateViewModel, _super);
        function ShopItemCreateViewModel() {
            _super.call(this);
            //#region properties
            this.selectedMemberTypes = ko.observableArray();
            this.uniqueItemId = "";
            this.steuerberaterId = "";
            this.steuerberaterCount = "";
            this.organizationFilter = "";
            this.anzahlstb = "";
            this.description = "";
            this.orgaTyp = "";
            this.shopId = "";
            this.memberTypes = ["PortalAdmin"];
            this.isExternalApplication = true;
            this.selectedOrganizations = ko.observableArray();
            this.organizations = new orgaRepository.OrganizationRepository();
            ko.track(this, ["shopitemstub", "name", "selectedNode", "uniqueItemId", "steuerberaterId", "memberTypes", "organizationFilter", "steuerberaterCount", "description", "isExternalApplication"]);
        }
        //#endregion
        // #region commands
        //public deleteCommand: DeleteShopItemTemplateCommand;
        //public editNodeCommand: Commanding.DelegateCommand<navimanModel.NavigationNodeVM>;
        //public navigateCommand: Commanding.DelegateCommand<navimanModel.NavigationNodeVM>;
        // public submitCommand: SubmitCommand;
        // #endregion
        ShopItemCreateViewModel.prototype.onActivated = function (context) {
            var that = this;
            this.initialize();
            var workStatus = $.t("app:modules.shopitemtemplate.message_loadShopItemStub", { ifMissing: "ShopItemStub wird geladen..." });
            return this.taskManager.startAsync(workStatus, function () {
                return that.readShopItemTemplateStubAsync(context.queryString.memberType, context.queryString.id)
                    .then(function (data) {
                    that.shopitemstub = data;
                });
            });
        };
        ShopItemCreateViewModel.prototype.initialize = function () {
            var _this = this;
            Parts.PartBinder.bind(new navimanLoadModules(), function (symbol) { return _this.modules = symbol; }).process({});
            // commands
            //this.editNodeCommand = new Commanding.DelegateCommand<navimanModel.NavigationNodeVM>(this.onEditNode, this);
            this.setUpController();
            this.attachEvents();
            this.getOrganizations();
            this.getMemberTypes();
            this.uniqueItemId = this.newGuid();
        };
        ShopItemCreateViewModel.prototype.getMemberTypes = function () {
            var _this = this;
            var that = this;
            that.memberTypes = [];
            return this.readMemberTypesAsync()
                .then(function (data) {
                _this.memberTypes = data;
            });
        };
        ;
        ShopItemCreateViewModel.prototype.readMemberTypesAsync = function () {
            var repository = new Repository.ShopItemTemplateRepository();
            return repository.getMemberTypes()
                .then(function (data) {
                return data;
            }).fail(function (error) {
                return null;
            });
        };
        ShopItemCreateViewModel.prototype.getOrganizations = function () {
            this.orgaController.override("findbynameanduri");
            if (!String.isNullOrEmpty(this.organizationFilter)) {
                this.orgaController.parameters = { Name: this.organizationFilter };
            }
            else {
                this.orgaController.parameters = { name: "" };
            }
            this.orgaController.filterDefinitions.modify(function (s) {
                s.remove("OrganizationType");
                s.add(Data.BreezeColumnFilter.contains("OrganizationType", "stb"));
            });
            this.orgaController.load();
        };
        ;
        ShopItemCreateViewModel.prototype.attachEvents = function () {
            var _this = this;
            ko.getObservable(this, "organizationFilter").subscribe(function (value) {
                _this.orgaController.parameters = { Name: _this.organizationFilter };
                _this.getOrganizations();
            });
        };
        ShopItemCreateViewModel.prototype.setUpController = function () {
            var _this = this;
            var params;
            if (this.orgaController == null) {
                this.orgaController = new Data.BreezeDataController(this.organizations, params).configure(function (result) { return result.map(function (s) { return orgaMapping.Mapper.mapOrganizationItemFromDTO(s); }); });
                this.orgaController.sortDefinitions.modify(function (s) { return s.add(_this.orgaController.buildSort("Name", "desc")); });
                this.orgaController.override("findbynameanduri", params);
            }
        };
        ShopItemCreateViewModel.prototype.setZuordnung = function (event) {
            var repository = new Repository.ShopItemTemplateRepository();
            if (this.selectedOrganizations() != null && this.selectedOrganizations().length > 0) {
                if (this.shopitemstub.targetOrganizations == null) {
                    this.shopitemstub.targetOrganizations = [];
                }
                for (var i = 0; i < this.selectedOrganizations().length; i++) {
                    var org = this.selectedOrganizations()[i];
                    // do stuff here    
                    this.shopitemstub.targetOrganizations.push(org.id);
                }
            }
            else {
                this.shopitemstub.targetOrganizations = null;
            }
            if (this.isValidGuid(this.uniqueItemId)) {
                this.shopitemstub.uniqueItemId = this.uniqueItemId;
            }
            else {
                var errorUid = $.t("app:modules.shopitemtemplate.message_uidNotValid", { ifMissing: "Die UniqueItemId is nicht valide" });
                Trace.traceError(errorUid);
                return;
            }
            this.shopitemstub.memberTypes = this.selectedMemberTypes();
            this.shopitemstub.description = this.description;
            this.shopitemstub.isExternalApplication = this.isExternalApplication;
            var shopItemStubDto;
            shopItemStubDto = Mapping.mapShopItemStubVm2ShopItemStubDto(this.shopitemstub);
            //repository.setZuordnung(shopItemStubDto)
            //    .then((data: any) => {
            //var messageRowsCreated = $.t("app:modules.shopitemtemplate.message_rowsCreated", { ifMissing: "Die ShopItem-Sätze wurden angelegt." });
            //Trace.traceInformation(messageRowsCreated);
            //        navigator.goBack();
            //    }).fail((exception) => {
            //var messageRowsCreated = $.t("app:modules.shopitemtemplate.message_rowsNotCreated", { ifMissing: "Es konnten keine ShoptItem-Sätze angelegt werden." });
            //Trace.traceError(messageRowsCreated + " Exception: " + exception.responseText, null, "shopitemtemplate", true);
            //        // Zurück auf die Liste
            //        navigator.goBack();
            //    });
        };
        ShopItemCreateViewModel.prototype.isValidGuid = function (guid) {
            var regex = '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$';
            var regexp = new RegExp(regex);
            return regexp.test(guid);
        };
        ShopItemCreateViewModel.prototype.cancel = function () {
            navigator.goBack();
        };
        ShopItemCreateViewModel.prototype.steuerberaterAuswahlLeerenCommand = function () {
            // UniqueItemId aus modalen Dialog übernehmen
            this.selectedOrganizations.removeAll();
            this.steuerberaterCount = "0";
        };
        ShopItemCreateViewModel.prototype.submitCommand = function (modul) {
            // UniqueItemId aus modalen Dialog übernehmen
            this.uniqueItemId = modul.uniqueItemId;
        };
        ShopItemCreateViewModel.prototype.submitOrganizationCommand = function () {
            // UniqueItemId aus modalen Dialog übernehmen
            //this.steuerberaterId = org.id;
            this.steuerberaterCount = this.selectedOrganizations().length.toString();
        };
        ShopItemCreateViewModel.prototype.newGuidCommand = function () {
            // UniqueItemId aus modalen Dialog übernehmen
            this.uniqueItemId = this.newGuid();
        };
        ShopItemCreateViewModel.prototype.newGuid = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
        ShopItemCreateViewModel.prototype.readShopItemTemplateStubAsync = function (memberType, id) {
            var repository = new Repository.ShopItemTemplateRepository();
            return repository.read(memberType, id)
                .then(function (data) {
                return Mapping.mapShopItemTemplate2ShopItemStubFromDTO(data);
            }).fail(function (error) {
                return null;
                //this.error.call(error);
            });
        };
        ShopItemCreateViewModel.prototype.readOrganizationsAsync = function () {
            var repository = new orgaRepository.OrganizationRepository();
            return repository.all()
                .then(function (data) {
                return data.results;
            }).fail(function (error) {
                return null;
            });
        };
        return ShopItemCreateViewModel;
    }(common.ViewModelBase));
    return ShopItemCreateViewModel;
});

